<!-- =========================================================================================
    File Name: Error404.vue
    Description: 404 Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div
    class="h-screen flex w-full bg-img"
    :style="`background-image: url('/assets/images/pages/login-bg_${appFilename}.jpg')`"
  >
    <div
      class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center"
    >
      <img src="../../assets/images/pages/404.png" alt="graphic-404" class="mx-auto mb-4 max-w-full" />
      <h1 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color">404 - Oops!</h1>
      <vs-button size="large" to="/">Home</vs-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appFilename: process.env.VUE_APP_FILENAME,
    };
  },
};
</script>
